<div *ngIf="policies && policies.length > 0; else noCustomerPolicies">
    <p-table
        [paginator]="true"
        [value]="policies"
        [rows]="9"
        [rowsPerPageOptions]="[10, 15, 20]"
        responsiveLayout="scroll"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>{{ 'PROVIDER_NAME' | translate }}</th>
                <th>{{ 'PACKAGE' | translate }}</th>
                <th>{{ 'INSURANCE_TYPE' | translate }}</th>
                <th>{{ 'MOTOR_POLICY_TYPE' | translate }}</th>
                <th>{{ 'VEHICLES_COVERED' | translate }}</th>
                <th>{{ 'SUM_ASSURED' | translate }}</th>
                <th>{{ 'STATUS' | translate }}</th>
                <th>{{ 'COVER_START_DATE' | translate }}</th>
                <th>{{ 'COVER_MATURITY_DATE' | translate }}</th>
                <th>{{ 'NEXT_RENEWAL_DATE' | translate }}</th>
                <th>{{ 'STATUS' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-policy>
            <tr>
                <td>
                    <span class="p-column-title">Provider Name</span>
                    {{ policy.providerName ? policy.providerName : "---" }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'PACKAGE' | translate }}</span>
                    {{ policy.packageName ? (policy.packageName | translate) : "---" }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'INSURANCE_TYPE' | translate }}</span>
                    {{ policy.insuranceType ? (policy.insuranceType | translate) : "---" }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'MOTOR_POLICY_TYPE' | translate }}</span>
                    {{
                        policy.motorPolicyType ? (policy.motorPolicyType | translate) : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Vehicles</span>
                    {{ policy.vehicles.length }}
                </td>
                <td>
                    <span class="p-column-title">Sum Assured</span>
                    {{ policy.sumAssured ? policy.sumAssured : "---" }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'STATUS' | translate }}</span>
                    {{ policy.status ? (policy.status | translate) : "---" }}
                </td>
                <td>
                    <span class="p-column-title">Cover Start Date</span>
                    {{
                        policy.coverStartDate
                            ? (policy.coverStartDate | date : "short")
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Cover Maturity Date</span>
                    {{
                        policy.maturityDate
                            ? (policy.maturityDate | date : "short")
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Next Renewal Date</span>
                    {{
                        policy.nextRenewalDate
                            ? (policy.nextRenewalDate | date : "short")
                            : "---"
                    }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'STATUS' | translate }}</span>
                    {{ policy.status ? (policy.status | translate) : "---" }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<ng-template #noCustomerPolicies>
    <div class="flex align-items-center">
        <i class="pi pi-exclamation-triangle mr-4"></i
        ><span>{{ 'NO_POLICIES' | translate }}</span>
    </div>
</ng-template>
